// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const coalossal_gmax: PokeData = {
  "id": 10215,
  "name": "coalossal-gmax",
  "height": 420,
  "weight": 10000,
  "base_experience": 255,
  "types": [
    PokeType.ROCK,
    PokeType.FIRE
  ],
  "api_moves": [],
  "moves": [
    "sunny-day",
    "ancient-power",
    "rock-throw",
    "magma-storm",
    "rock-blast",
    "rock-slide",
    "flamethrower",
    "stone-crush",
    "eruption",
    "ember",
    "rock-smash",
    "fire-punch",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 441,
    "item": null,
    "species": [
      {
        "name": "rolycoly",
        "order": 837,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "carkol",
        "order": 838,
        "types": [
          PokeType.ROCK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 837,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "coalossal",
        "order": 839,
        "types": [
          PokeType.ROCK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 838,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 198,
    "speed": 55,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
